import React from 'react'
import {FooterHelp, Link, Page} from '@shopify/polaris'

import ItemListComponent from '../../components/item-list'

const Sliders = (props) => {
  return (
    <Page
      fullWidth
      title='Sliders'
      primaryAction={{
        content: 'Add Slider',
        url: '/sliders/new'
      }}
    >
      <ItemListComponent
        resourceName={{
          singular: 'slider',
          plural: 'sliders'
        }}
        endpoint={`/api/v2/admin/sliders`}
      />
      <FooterHelp>
        Learn more about<Link url="/docs#/create-your-first-slider" external> creating your first slider</Link>
      </FooterHelp>
    </Page>
  )
}

export default Sliders
